/** Display helpers for bridge staff from API (owners[], admins[], managers[]) */

export const getStaffName = (person) =>
  person?.name?.trim() || person?.user?.name?.trim() || '';

export const getStaffEmail = (person) =>
  person?.email?.trim() || person?.user?.email?.trim() || '';

export const formatStaffPhone = (person) => {
  if (!person?.phone) return '';
  const code = String(person.countryCode || '').replace(/^\+/, '');
  return code ? `+${code} ${person.phone}` : person.phone;
};

export const formatStaffNames = (list) => {
  const names = (list || []).map(getStaffName).filter(Boolean);
  return names.length ? names.join(', ') : '—';
};

/** One name per line for read-only fields */
export const formatStaffNameLines = (list) => {
  const names = (list || []).map(getStaffName).filter(Boolean);
  return names.length ? names.join('\n') : '—';
};

/** All engineers nested under bridge managers */
export const collectEngineersFromManagers = (managers) => {
  const engineers = [];
  (managers || []).forEach((m) => {
    (m.engineers || []).forEach((e) => engineers.push(e));
  });
  return engineers;
};

export const formatManagersSummary = (managers) => formatStaffNames(managers);
